import React from 'react';
import { DATA_GRID_COLUMN_TYPES } from 'src/types/formQuestionnaire';
import { renderInputField } from './shared';
import { BaseInputProps } from './types';

export const NumericInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  textInputPlaceholder,
}) =>
  renderInputField({
    type: DATA_GRID_COLUMN_TYPES.NUMBER,
    value: answers[currentQuestion.id]?.numeric || '',
    onChange: (e) =>
      dispatch({
        type: 'SET_NUMERIC',
        questionId: currentQuestion.id,
        payload: e.target.value,
      }),
    placeholder: textInputPlaceholder,
    testId: 'form-preview-numeric-input',
  });
